<template>
  <div class="GoodsItem2" @click="tapEvent">
    <van-image
      fit="cover"
      class="pic"
      :src="goodsInfo.PictUrl"
      error-icon="photo"
    />
    <div class="rightPart">
      <div class="subTopPart">
        <div class="title twoRow"><plat-formLogo :shopType="$utils.shopTypeNumChangeToText(goodsInfo.UserType)"></plat-formLogo>{{ goodsInfo.Title }}</div>
        <div class="coupon" v-if="goodsInfo.CouponTotalAmount">
          领券{{ goodsInfo.CouponTotalAmount }}元
        </div>
        <div class="subBottom">
          <span class="price">
            <i class="symbol">￥</i>
            <i class="integer">{{
              $utils.SplitPrice(goodsInfo.CouponFinalPrice)[0]
            }}</i>
            <i class="decimal"
              >.{{ $utils.SplitPrice(goodsInfo.CouponFinalPrice)[1] }}</i
            >
          </span>
          <span class="subsidy" v-if="goodsInfo.TljAmount"
            >补贴{{ goodsInfo.TljAmount }}元</span
          >
        </div>
        <progress-bar
          class="progressBar"
          :isTljGone="goodsInfo.IsTljGone"
        ></progress-bar>
      </div>
    </div>
  </div>
</template>

<script>
import { Image as VanImage } from "vant";
import ProgressBar from "./ProgressBar";
import { mapMutations } from "vuex";
export default {
  props: {
    goodsInfo: {
      type: Object,
      default: () => {
        return {
          PictUrl: "",
          Title: "",
          CouponFinalPrice: "",
        };
      },
      required: false,
    },
  },
  data() {
    return {};
  },
  components: {
    VanImage,
    ProgressBar,
  },
  methods: {
    ...mapMutations(["SET_GOODS_DETAIL_DATA"]),
    tapEvent() {
      this.SET_GOODS_DETAIL_DATA(this.goodsInfo);
      this.$emit("entotTLJDetailPage", this.goodsInfo.NumIID);
    },
  },
  filters: {
    titleFilter(val) {
      let tempStr = val;
      tempStr = tempStr.replace("【", "(");
      tempStr = tempStr.replace("】", ")");
      return tempStr;
    },
  },
};
</script>

<style scoped lang="scss">
$base_width: 375;
@function vw($px) {
  @return ($px / $base_width) * 100vw;
}
.GoodsItem2 {
  display: flex;
  flex-direction: column;
  width: 100%;
  // height: vw(135);
  // margin-bottom: vw(10);
  margin: 0 auto vw(10);
  border-radius: vw(5);
  background-color: #fff;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  .pic {
    width: 100%;
    min-height: vw(175);
    overflow: hidden;
    flex-shrink: 0;
    border-top-left-radius: vw(5);
    border-top-right-radius: vw(5);
  }
  // &:last-child {
  //   margin-bottom: 0;
  // }
  .rightPart {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1;
    height: 100%;
    box-sizing: border-box;
    padding: vw(8) vw(8) vw(12);
    .subTopPart {
      .title {
        font-size: vw(15);
        line-height: normal;
        max-height: none;
      }
      .coupon {
        font-size: vw(12);
        color: #999999;
        margin: vw(4) 0 0;
        line-height: 1em;
      }
      .progressBar {
        position: relative;
        left: vw(-1);
      }
    }
    .subBottom {
      width: 100%;
      margin-top: vw(12);
      .price {
        position: relative;
        top: vw(3);
        font-size: vw(12);
        line-height: 1;
        color: #f23030;
        .symbol {
          position: relative;
          top: -1px;
        }
        i {
          font-style: normal;
          line-height: 1;
        }
        .integer {
          position: relative;
          font-size: vw(24);
          line-height: 1;
          letter-spacing: -1px;
        }
        .decimal {
          font-size: vw(16);
          line-height: 1;
          // letter-spacing: -1px;
        }
      }
      .subsidy {
        display: inline-block;
        position: relative;
        top: vw(-2);
        background-color: #fae6b4;
        color: #e18f22;
        font-size: vw(11);
        padding: 0 vw(7) 0 vw(6);
        height: vw(18);
        line-height: vw(18);
        border-radius: vw(9);
        border-bottom-left-radius: 0;
        margin-left: vw(10);
      }
    }
  }
}
</style>
